<template>
  <div class="token-page">
    <token-top-block />
    <token-services-data />
    <token-network />
    <token-ecosystem />
    <token-consume />
    <token-income-source />
    <token-what-does-cpex />
    <token-level-system />
    <token-benefits />
    <crypto-academy
      with-circle-corners
      bg-color-class="bg--color-10"
      bg-container-class="bg--color-01"
    />
    <token-cpex-in-academy />
    <token-how-to-get />
    <faq-block bg-color-class="bg--color-11" />
    <subscribe-block />
  </div>
</template>

<script>
import { getDefaultHeadData } from '@/lib/utils'

export default {
  name: 'TokenPage',
  components: {
    TokenTopBlock: () => import('@/components/token/new/TokenTopBlock.vue'),
    TokenServicesData: () => import('@/components/token/new/TokenServicesData.vue'),
    TokenConsume: () => import('@/components/token/new/TokenConsume.vue'),
    TokenIncomeSource: () => import('@/components/token/new/TokenIncomeSource.vue'),
    TokenWhatDoesCpex: () => import('@/components/token/new/WhatDoesCpex.vue'),
    TokenLevelSystem: () => import('@/components/token/new/TokenLevelSystem.vue'),
    TokenNetwork: () => import('~/components/token/new/TokenNetwork.vue'),
    TokenEcosystem: () => import('@/components/token/new/TokenEcosystem.vue'),
    TokenBenefits: () => import('@/components/token/new/TokenBenefits.vue'),
    CryptoAcademy: () => import('@/components/token/new/CryptoAcademy.vue'),
    TokenCpexInAcademy: () => import('@/components/token/new/TokenCpexInAcademy.vue'),
    FaqBlock: () => import('@/components/welcome/FaqBlock.vue'),
    SubscribeBlock: () => import('@/components/welcome/SubscribeBlock.vue'),
    TokenHowToGet: () => import('@/components/token/new/TokenHowToGet.vue'),
  },
  head () {
    return getDefaultHeadData({
      title: this.$t('meta.network.title'),
      description: this.$t('meta.network.description'),
      img: '/image/meta/og-network.png',
      locale: this.$i18n.locale,
    })
  },
}
</script>

<style lang="scss" scoped>
.token-page {
  // &__faq-block {
  //   border-radius: toRem(20px) toRem(20px) 0 0;
  //   margin-top: toRem(-20px);

  //   @include bp(l) {
  //     margin-top: toRem(-60px);
  //     border-radius: toRem(60px) toRem(60px) 0 0;
  //   }
  // }
}
</style>
